import CustomEventEmitter from "../../helper/event-emitter";

const eventEmitter = CustomEventEmitter.getInstance();

const documentSlashOptions: any[] = [
  {
    title: "H1",
    command: (object: any) => {
      let editor = object.editor;
      let range = object.range;
      editor
        .chain()
        .focus()
        .deleteRange(range)
        .setNode("heading", { level: 1 })
        .run();
    },
    ClassName: "far fa-h1",
  },
  {
    title: "H2",
    command: (object: any) => {
      let editor = object.editor;
      let range = object.range;
      editor
        .chain()
        .focus()
        .deleteRange(range)
        .setNode("heading", { level: 2 })
        .run();
    },
    ClassName: "far fa-h2",
  },
  {
    title: "H3",
    command: (object: any) => {
      let editor = object.editor;
      let range = object.range;
      editor
        .chain()
        .focus()
        .deleteRange(range)
        .setNode("heading", { level: 3 })
        .run();
    },
    ClassName: "far fa-h3",
  },
  {
    title: "bold",
    command: (object: any) => {
      let editor = object.editor;
      let range = object.range;
      editor.chain().focus().deleteRange(range).toggleBold("bold").run();
    },
    ClassName: "far fa-bold",
  },
  {
    title: "italic",
    command: (object: any) => {
      let editor = object.editor;
      let range = object.range;
      editor.chain().focus().deleteRange(range).toggleItalic("italic").run();
    },
    ClassName: "far fa-italic",
  },
  {
    title: "Bullet List",
    command: (object: any) => {
      let editor = object.editor;
      let range = object.range;
      editor.chain().focus().deleteRange(range).toggleBulletList().run();
    },
    ClassName: "far fa-list",
  },
  {
    title: "Ordered List",
    command: (object: any) => {
      let editor = object.editor;
      let range = object.range;
      editor.chain().focus().deleteRange(range).toggleOrderedList().run();
    },
    ClassName: "far fa-list-ol",
  },
  {
    title: "Table",
    command: (object: any) => {
      let editor = object.editor;
      let range = object.range;
      editor
        .chain()
        .focus()
        .deleteRange(range)
        .insertTable({ rows: 4, cols: 4, withHeaderRow: true })
        .run();
    },
    ClassName: "fal fa-table",
  },
  {
    title: "Quote",
    command: (object: any) => {
      let editor = object.editor;
      let range = object.range;
      editor.chain().focus().deleteRange(range).toggleBlockquote().run();
    },
    ClassName: "far fa-quote-left",
  },
  {
    title: "Code",
    command: (object: any) => {
      let editor = object.editor;
      let range = object.range;
      editor.chain().focus().deleteRange(range).toggleCode().run();
    },
    ClassName: "far fa-code",
  },
  {
    title: "Image",
    command: (object: any) => {
      let editor = object.editor;
      let range = object.range;
      editor.chain().focus().deleteRange(range).run();
    },
    ClassName: "far fa-image",
  },
  {
    title: "Divider",
    command: (object: any) => {
      let editor = object.editor;
      let range = object.range;
      editor.chain().focus().deleteRange(range).setHorizontalRule().run();
    },
    ClassName: "far fa-divide",
  },
  {
    title: "Attachments",
    command: (object: any) => {
      let editor = object.editor;
      let range = object.range;
      editor.chain().focus().deleteRange(range).run();
      eventEmitter.emit("documentEvent", {
        methodName: "showAddAttachmentDialog",
      });
    },
    ClassName: "far fa-paperclip",
  },
  {
    title: "Image Carousel",
    command: (object: any) => {
      let editor = object.editor;
      let range = object.range;
      editor.chain().focus().deleteRange(range).run();
      eventEmitter.emit("documentEvent", {
        methodName: "ImageCarouselAddEvent",
      });
    },
    ClassName: "far fa-gallery-thumbnails",
  },
];

export class DocumentDraft {
  public entityId: string;
  public docTitle: string;
  public documentHTML: string;
  public parentDocumentId: string;
}

export class UploadedDocumentAttachments {
  public blobPath: string;
  public name: string;
}

export default documentSlashOptions;
